import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import ServicesTab from "../components/services/ServicesTab";
import CategoriesTab from "../components/services/CategoriesTab"

let Services = class extends React.Component {
    render() {
        return (
            <Tabs defaultActiveKey='services' id='callback-tabs' unmountOnExit={true}>
                <Tab eventKey='services' title='Услуги'>
                    <ServicesTab />
                </Tab>
                <Tab eventKey='categories' title='Категории'>
                    <CategoriesTab />
                </Tab>
            </Tabs>
        );
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/containers/Services.jsx